package com.vizio.redwolf.auth.model

import kotlinx.serialization.Serializable

@Serializable
internal data class MigrateGuestClientRequestInfo(
    val email: String,
    val password: String,
    val birthDate: String? = null,
    val gender: String? = null
)